import React from 'react'
import Icon from '@material-ui/core/Icon'

const star = () => <Icon style={{ fontSize: 60 }}>star</Icon>

export default star



// WEBPACK FOOTER //
// ./src/components/Star/index.jsx